function Hello_World(){
    return<h1>Kaja Thiel 21310</h1>;
}

export default Hello_World;